<template>
  <input
    ref="inputRef"
    :id="props.id"
    :type="props.type"
    :placeholder="placeholder"
    :disabled="props.disabled"
    :class="classes"
    :autocomplete="props.autocomplete"
    v-model="inputValue"
  />
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useAlertStore } from '@stores';
import { ERROR_MESSAGES } from '@constants';
import {
  formatBirthday,
  phoneNumberFormatter,
  // isEmail,
  // isPwd,
} from '@core/utils';

interface IProps {
  id: string;
  type?: string;
  modelValue: string;
  placeholder?: string;
  max?: string;
  onlyNumber?: boolean;
  disabled?: boolean;
  phone?: boolean;
  birthday?: boolean;
  autocomplete?: string;
  email?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  id: '',
  type: 'text',
  modelValue: '',
  placeholder: '아이디. 비밀번호',
  max: '',
  onlyNumber: false,
  disabled: false,
  autocomplete: 'off',
  email: false,
});

const emits = defineEmits(['update:modelValue']);
const inputValue = ref<string>(props.modelValue);
const alertStore = useAlertStore();
const inputRef = ref<HTMLInputElement | null>(null);
const classes = computed(() => {
  const disabled = props.disabled ? 'disabled' : '';
  return `${disabled}`;
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (props.phone || props.birthday) {
      const removeHyphenStr = newValue.replace(/[^0-9]/g, '');
      if (props.phone) {
        inputValue.value = phoneNumberFormatter(removeHyphenStr);
      } else if (props.birthday) {
        inputValue.value = formatBirthday(removeHyphenStr);
      }
    } else {
      inputValue.value = newValue;
    }
  }
);

watch(
  () => inputValue.value,
  (newValue, oldValue) => {
    if (props.max && newValue.length > Number(props.max)) {
      alertStore.showAlertDialog(ERROR_MESSAGES['EXCEED_MAX_VALUE']);
      inputValue.value = oldValue;
      return;
    }
    if (props.onlyNumber) {
      const regExp = /^[0-9]*$/;
      if (!regExp.test(newValue)) {
        inputValue.value = oldValue;
        return;
      }
    }
    if (props.phone || props.birthday) {
      const removeHyphenString = newValue.replace(/-/g, '');
      emits('update:modelValue', removeHyphenString);
      return;
    }
    emits('update:modelValue', newValue);
  }
);

// const handleBlur = async () => {
// const input = inputRef.value;
// if (props.email && inputValue.value && !isEmail(inputValue.value)) {
//   await alertStore.showAlertDialog('올바른 이메일 형식이 아닙니다.');
//   inputRef.value?.focus();
// }
// if (
//   input?.getAttribute('autocomplete') === 'new-password' &&
//   inputValue.value
// ) {
//   const min = 8;
//   const max = 16;
//   const isValidPwd = isPwd({
//     pwd: inputValue.value,
//     type: 'A',
//     min,
//     max,
//   });
//
//   if (!isValidPwd) {
//     await alertStore.showAlertDialog(
//       `비밀번호는 영문대문자, 소문자, 숫자, 특수문자 중 <br/>2가지 이상 조합하여 ${min}~${max}자리로 입력해주세요.`
//     );
//     input.focus();
//   }
// }
// };
</script>

<style scoped lang="scss">
input {
  border-bottom: 2px solid #222;
  width: 100%;
  height: 48px;
  padding: 14px 16px;
  font-weight: 400;
  background-color: #fff;
  position: relative;
  &[type='text'][autocomplete='new-password'] {
    -webkit-text-security: disc;
    -webkit-password-visibility: hidden;
    -webkit-password-reveal: none;
    font-family: text-security-disc; /* 일부 브라우저 호환성을 위한 대체 폰트 */
  }
}

input:focus {
  outline: none;
  border-bottom: 2px solid var(--color-main);
}

input::placeholder {
  color: #aaa;
}

input:focus::placeholder {
  display: block;
}

input:disabled {
  background-color: #f9f9f9;
  border: 1px solid #f9f9f9;
}

input:disabled::placeholder {
  color: #5f6668;
}

@media (max-width: 884px) {
}
</style>
